import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import React, { useEffect } from 'react';
import { AdminUser } from 'src/types/shared/AdminUser';

import useUpdateSuperAdmin from './hooks/useUpdateSuperAdmin';
import usePrevious from 'lib/src/hooks/usePrevious';
import Select from '@components/form/Select';

const UpdateSuperAdminModal: React.FC<UpdateSuperAdminProps> = ({ user, closeModal }) => {
    const {
        handleSubmit,
        handleChange,
        isPosting,
        formState: { email, firstName, lastName, site },
        postSuccess,
        siteOptions,
        shouldShowSiteOptions,
    } = useUpdateSuperAdmin(user);

    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
        }
    }, [postSuccess, prevPostSuccess, closeModal]);

    return (
        <Modal title="Update super admin" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleChange}
                        label="Email address"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="firstName"
                        value={firstName}
                        onChange={handleChange}
                        label="First name"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="lastName"
                        value={lastName}
                        onChange={handleChange}
                        label="Last Name"
                        required
                    />
                </FormRow>
                {shouldShowSiteOptions && (
                    <FormRow>
                        <Select
                            name="site"
                            value={site}
                            options={siteOptions}
                            onChange={handleChange}
                            label="Site"
                            required
                        />
                    </FormRow>
                )}
            </Form>
        </Modal>
    );
};

interface UpdateSuperAdminProps {
    user: AdminUser;
    closeModal: () => void;
}

export default UpdateSuperAdminModal;
